import {
  StyleProp,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from "react-native";
import React, { useState } from "react";
import { SentryFeedbackModal } from "./SentryFeedbackModal";

const styles = StyleSheet.create({
  feedbackButton: {
    position: "absolute",
    bottom: 16,
    right: 40,
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#7EADEB",
    paddingVertical: 4,
    paddingLeft: 13,
    paddingRight: 24,
    borderRadius: 100,
    gap: 8,
  },
  iconContainer: {
    width: 18,
    height: 20,
    justifyContent: "center",
    alignItems: "center",
  },
  chatIcon: {
    width: 18,
    height: 16,
    borderWidth: 2,
    borderColor: "#F6F7F9",
    borderRadius: 4,
    position: "relative",
  },
  chatTail: {
    position: "absolute",
    bottom: -4,
    left: 2,
    width: 0,
    height: 0,
    borderLeftWidth: 4,
    borderRightWidth: 4,
    borderTopWidth: 4,
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
    borderTopColor: "#F6F7F9",
  },
  feedbackText: {
    color: "#F6F7F9",
    fontSize: 11,
    fontFamily: "Lexend",
    fontWeight: "400",
    lineHeight: 22,
  },
});

export function FeedbackFabButton({ style }: { style?: StyleProp<ViewStyle> }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <TouchableOpacity
        style={[styles.feedbackButton, style]}
        onPress={() => setIsOpen(true)}
        accessibilityRole="button"
        accessibilityLabel="Send feedback"
      >
        <View style={styles.iconContainer}>
          <View style={styles.chatIcon}>
            <View style={styles.chatTail} />
          </View>
        </View>
        <Text style={styles.feedbackText}>FEEDBACK</Text>
      </TouchableOpacity>

      <SentryFeedbackModal visible={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
